import { render } from "./QuotaBalance.vue?vue&type=template&id=25d799a4"
import script from "./QuotaBalance.vue?vue&type=script&lang=js"
export * from "./QuotaBalance.vue?vue&type=script&lang=js"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__